import { api } from '../lib/api'

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
}

export type ChatMode = 'chat' | 'interview'

export interface ChatConversationSummary {
  id: string
  title: string | null
  mode: ChatMode
  reportId: string | null
  createdAt: string
  updatedAt: string
  messageCount: number
}

export interface ChatReply {
  conversationId: string
  reply: string
  model: string
  // Fatos/metas que a IA gravou no dossiê nesta rodada (o gerente afirmou).
  saved: string[]
}

/** Fato que a IA gravou no dossiê durante a conversa (estado atual dele). */
export interface SavedFact {
  id: string
  content: string
  category: string
  active: boolean
  status: 'proposed' | 'confirmed' | 'rejected'
  createdAt: string
}

/** Uma conversa é salva no servidor: o front manda só a pergunta nova. */
export interface ChatSendInput {
  conversationId?: string | null
  message: string
  mode?: ChatMode
}

export const chatApi = {
  send: (clientId: string, input: ChatSendInput) => api.post<ChatReply>(`/chat/${clientId}`, input),
  // Conversa com escopo de UM relatório (conteúdo do relatório injetado no backend).
  sendForReport: (reportId: string, input: ChatSendInput) =>
    api.post<ChatReply>(`/chat/report/${reportId}`, input),
  conversations: (clientId: string, reportId?: string) =>
    api.get<{ conversations: ChatConversationSummary[] }>(
      `/chat/${clientId}/conversations${reportId ? `?reportId=${encodeURIComponent(reportId)}` : ''}`
    ),
  conversation: (id: string) =>
    api.get<{
      conversation: { id: string; clientId: string; reportId: string | null; mode: ChatMode; title: string | null }
      messages: Array<ChatMessage & { id: string; createdAt: string }>
      savedFacts: SavedFact[]
    }>(`/chat/conversations/${id}`),
  remove: (id: string) => api.del<{ ok: true }>(`/chat/conversations/${id}`),
}
